module.exports = __webpack_public_path__ + "img/njzcw_banner_img.9181d9c7.png";